import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IEmbeddedVideoProps } from '../components/embededded-video/embededded-video';
import { Truthy } from '../utils/utils';

export class EmbededdedVideoModel extends ContentItem {
  get videoURL(): string {
    return get(this._config, 'elements.video_url.value', '');
  }
  get width(): string {
    return get(this._config, 'elements.width.value', '');
  }
  get height(): string {
    return get(this._config, 'elements.height.value', '');
  }
  get allowFullscreen(): boolean {
    const getFullScreen = get(
      this._config,
      'elements.allow_fullscreen.value',
      ''
    );
    return Truthy.test(getFullScreen);
  }
  get allowProperties(): string {
    return get(this._config, 'elements.allow_properties.value', '');
  }
  get justifyContent(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_column.value[0].codename',
      'center'
    );
  }

  get alignItems(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_row.value[0].codename',
      'center'
    );
  }

  public static create(data: IEmbeddedVideoData): IEmbeddedVideoProps {
    const {
      videoURL,
      width,
      height,
      allowProperties,
      allowFullscreen,
      justifyContent,
      alignItems
    } = new EmbededdedVideoModel(data);

    return {
      videoURL,
      width,
      height,
      allowProperties,
      allowFullscreen,
      justifyContent,
      alignItems
    };
  }
}
